<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  /**
   * A sticky-top header row for a combobox dropdown, placed as the first child
   * of `ComboboxContent` (or fed to `InputGroupCombobox`'s `content-header`
   * slot). Lays out a `ComboboxHeaderTitle` and an optional trailing action
   * (e.g. a "Manage" button) on one bordered row. See `AgencyPicker` /
   * `PortPicker`.
   */
  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>

<template>
  <div
    data-slot="combobox-header"
    :class="
      cn(
        'border-border flex items-center justify-between gap-2 border-b px-3 py-1.5',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
